import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@shared/types/base-query';
import type { TInterviewer } from '@shared/types/interviewer';

export type TInterviewerQuery = {
  email?: string;
  search?: string;
  type?: TInterviewer['type'];
} & TBaseQuery;

type TInterviewerPayload = {
  name: string;
  avatar?: File | string;
  email: string;
  job_title: string;
  company_name: string;
  member?: number;
  type?: string;
};

const interviewerApi = createCrudService<
  TInterviewer,
  TInterviewerQuery,
  TInterviewerPayload
>({
  queryKey: [QUERY_KEYS.getInterviewers],
  url: 'interviewers',
});

export default interviewerApi;
